import React from 'react';
import { useSnackbar } from 'notistack';
import { Card, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Button, Stack, Typography } from '@mui/material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
// import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import { API_URL, FILE_UPLOAD_TYPE } from '../constant';
import axios from 'axios';
import { isEmpty } from 'lodash';

const TABLE_HEAD = [
    { id: 'reference_name', label: 'Name', alignLeft: true },
    { id: 'reference_mobile', label: 'Mobile' },
    { id: 'type', label: 'Type' },
    { id: 'verified', label: 'Verified' },
    { id: 'remarks', label: 'Remarks' },
    { id: 'upload', label: 'Upload' },
    // { id: 'download', label: 'Download' }
];

const TvrList = ({ data }) => {
    const { enqueueSnackbar } = useSnackbar();

    const handleUpload = async (event, row) => {
        const file = event.target.files[0];
    
        if (!file) return; // Exit if no file is selected
    
        console.log(`Uploading file for Loan ID ${row.loan_id}:`, file);
    
        const body = {
            ...row,
          staff_id: row.uploaded_by,
          is_edit: true,
        };
    
        const formData = new FormData();
        formData.append('data', JSON.stringify(body));
        formData.append(FILE_UPLOAD_TYPE.TVR_RECORDING, file); // Append the selected file
    
        try {
          await axios.post(`${API_URL}/loan/${body.loan_id}/tvr`, formData);
          enqueueSnackbar('File uploaded successfully!', { variant: 'success' });
        } catch (error) {
          console.error('Upload failed:', error);
          enqueueSnackbar('File upload failed!', { variant: 'error' });
        }
      };

    /*
    const handleDownload = (id) => {
        console.log(`Downloading file for ID ${id}`);
        // Handle file download logic here
    };
    */

    return (
        <Card sx={{ p: 3, boxShadow: 3, borderRadius: 2, mt: 3 }}>
            {/* Title */}
            <Stack
                direction="row"
                alignItems="center"
                justifyContent="space-between"
                sx={{ mb: 2, borderBottom: 1, borderColor: 'divider', pb: 1 }}
            >
                <Typography variant="h4" sx={{ fontWeight: 'bold', fontFamily: 'sans-serif', color: 'primary.main' }}>Tvr Detail</Typography>
            </Stack>
        <TableContainer component={Paper}>
            <Table>
            <TableHead>
                <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
                {TABLE_HEAD.map((head) => (
                    <TableCell key={head.id} align={head.alignLeft ? 'left' : 'center'} sx={{ fontWeight: 'bold' }}>
                    {head.label}
                    </TableCell>
                ))}
                </TableRow>
            </TableHead>
            <TableBody>
                {!isEmpty(data) && data?.map((row, index) => (
                <TableRow key={index}>
                    <TableCell align="left">{row.reference_name}</TableCell>
                    <TableCell align="center">{row.reference_mobile}</TableCell>
                    <TableCell align="center">{row.type}</TableCell>
                    <TableCell align="center">{row.verified ? 'Yes' : 'No'}</TableCell>
                    <TableCell align="center">{row.remarks}</TableCell>
                    <TableCell align="center">
                    <Button variant="contained" component="label" startIcon={<CloudUploadIcon />}  disabled={row.verified}>
                        Upload
                        <input type="file" accept="audio/*" hidden onChange={(event) => handleUpload(event, row)}/>
                    </Button>
                    </TableCell>
                    {/* <TableCell align="center">
                    <Button variant="outlined" startIcon={<CloudDownloadIcon />} onClick={() => handleDownload(row.id)}>
                        Download
                    </Button>
                    </TableCell> */}
                </TableRow>
                ))}
            </TableBody>
            </Table>
        </TableContainer>
        </Card>
    );
};

export default TvrList;
